/**
 * Utility to setup admin user
 * Run this in browser console after logging in as a regular user
 * 
 * Usage:
 * 1. Login to the website as a regular user
 * 2. Open browser console (F12)
 * 3. Copy and paste this code:
 * 
 * import { addAdminUser } from './firebase/helpers';
 * import { auth } from './firebase/config';
 * 
 * const user = auth.currentUser;
 * if (user) {
 *   addAdminUser(user.uid, user.email).then(() => {
 *     console.log('✅ You are now an admin! Please refresh the page.');
 *   }).catch(err => {
 *     console.error('❌ Error:', err);
 *   });
 * } else {
 *   console.log('❌ Please login first');
 * }
 */

import { addAdminUser } from '../firebase/helpers';
import { auth } from '../firebase/config';

/**
 * Setup current logged-in user as admin
 * Call this function from browser console after logging in
 */
export const setupCurrentUserAsAdmin = async () => {
  try {
    const user = auth.currentUser;
    if (!user) {
      throw new Error('Please login first as a regular user');
    }

    await addAdminUser(user.uid, user.email);
    console.log('✅ Success! You are now an admin.');
    console.log('🔄 Please refresh the page and login again to access admin panel.');
    return true;
  } catch (error) {
    console.error('❌ Error setting up admin:', error);
    throw error;
  }
};

// Make it available globally for easy access from console
if (typeof window !== 'undefined') {
  window.setupAdmin = setupCurrentUserAsAdmin;
}

